import { companyService } from "../service";
import { toast } from "react-toastify";
import {
    setcompaniesError,
    setcompaniesData,
  } from "../slice/companySlice";


const getCompanyListAsync =
  (page, limit, filter,t) => async (dispatch) => {
    // dispatch(setcompaniesLoading());
    try {
      const response = await companyService.getCompanyList(page, limit, filter);
      if (response?.data.error || response?.data.Error) {
        dispatch(setcompaniesError(response));
        dispatch(setcompaniesData({}));
        //toast.error(t(response?.data?.error?.error_code),{ toastId: 3 });
      } else {
        dispatch(setcompaniesData(response?.data));
        dispatch(setcompaniesError({}));
      }
    } catch (error) {
      dispatch(setcompaniesError(error));
    }
  };

  export const companyAction = {
    getCompanyListAsync,

  };